import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocTypeNoteAndCategoryNotApgRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const policyHolderId = control.get('policyHolderId')!.value;
	const country = control.get('country')!.value;

	return  documentCategory !== 'EGD02'  &&  documentType === 'EGD033' && (!country && !policyHolderId) ?
		{ checkDocTypeNoteAndCategoryNotApgFlag: true } : null;

};
